import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom';
import { ContentHeader } from '../../layout/Content'
import Searchbar from '../../layout/searchbar/Searchbar'
import ToolbarButton  from '../../layout/ToolbarButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import InvoiceListHeaderStyle from './css/InvoiceListHeaderStyle'
import InvoiceController from '../invoice/InvoiceController'
import InvoiceListSettingsForm from './forms/InvoiceListSettingsForm'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import { appContext } from '../../../App'
import { invoiceListControllerContext } from './InvoiceListController'

function ToolBarButtons(props) {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const searchInput = props.searchInput[0]
  const invoiceListController = useContext(invoiceListControllerContext)
  const { refreshInvoiceList, deleteSelectedInvoices } = invoiceListController
  const selectedInvoicesId = invoiceListController.selectedInvoicesId[0]

  const onClickSettings = (e) => {
    ReactDOM.render(
      <ModalWindow id='mw-parent' width='30' height='50' header='Settings' footer={null}>
        <InvoiceListSettingsForm app={app} invoiceListController={invoiceListController} />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickAddNewInvoice = (e) => { setContent(<InvoiceController />) }

  const onClickDeleteSelectedClients = (e) =>  {
    const showDeleteInvoiceMessageBox = () => {
      const onClick = (button) => {
        if (button === 'Yes') deleteSelectedInvoices()
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          header="Deleting invoices..."
          width='30'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>Deleting invoice will also restores it's items back to inventory.</div>
              <br />
              <div>Do you want to continue?</div>
              <br />
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn top-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    showDeleteInvoiceMessageBox()
  }

  return (
    <ToolbarButton>
      <button
        type="button"
        className={ searchInput ? 'pospro-action-btn toolbar-btn disabled-button' : 'pospro-action-btn toolbar-btn' }
        id="refresh-list"
        disabled={searchInput}
        name="tb"
        onClick={() => { refreshInvoiceList() }}
        title='Refresh list'>
        <FontAwesomeIcon icon='sync-alt'/>
        <span className='tooltip-text'>Refresh list</span>
      </button>
      <button
        type="button"
        className="pospro-action-btn toolbar-btn"
        id="settings"
        name="tb"
        onClick={onClickSettings}
        title='Settings'>
        <FontAwesomeIcon icon='cog'/>
        <span className='tooltip-text'>Settings</span>
      </button>
      <button
        type="button"
        className="pospro-action-btn toolbar-btn"
        id="add-new-invoice"
        name="tb"
        onClick={onClickAddNewInvoice}
        title='Create new invoice'>
        <FontAwesomeIcon icon='plus'/>
        <span className='tooltip-text'>Create new invoice</span>
      </button>
      <button
        type="button"
        className={ selectedInvoicesId.length ? 'pospro-action-btn toolbar-btn' : 'pospro-action-btn disabled-button' }
        id="batch-delete"
        disabled={!selectedInvoicesId.length}
        name="tb"
        onClick={onClickDeleteSelectedClients}
        title='Batch delete'>
        <FontAwesomeIcon icon='trash'/>
        <span className='tooltip-text'>Batch delete</span>
      </button>
    </ToolbarButton>
  )
}

function InvoiceListHeader() {
  const app = useContext(appContext)
  const [searchInput, setSearchInput] = useState('')
  const invoiceListController = useContext(invoiceListControllerContext)
  const { filterInvoiceList } = invoiceListController
  const searchbarProps = {
    search: searchInput,
    setSearch: setSearchInput,
    filter: filterInvoiceList
  }

  return (
    <ContentHeader title="Invoice's List">
      <div className="header-container">
        <div id="invoiceslist-toolbar">
          <Searchbar { ...searchbarProps } />
          <ToolBarButtons searchInput={[searchInput, setSearchInput]} />
        </div>
      </div>
      <InvoiceListHeaderStyle signed_in={app.client.signed_in}/>
    </ContentHeader>
  )
}

export default React.memo(InvoiceListHeader)